import { idSchema } from "@reactive-resume/schema";
import { dateSchema } from "@reactive-resume/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";
import { permissionSchema } from "../permission";

export const roleSchema = z.object({
  id: idSchema,
  name: z.string().min(3).max(100),
  description: z.string().optional().nullable(),
  isSystem: z.boolean().default(false),
  permissions: permissionSchema.array().default([]),
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

export class RoleDto extends createZodDto(roleSchema) {}

export const createRoleSchema = roleSchema.pick({
  name: true,
  description: true,
});

export class CreateRoleDto extends createZodDto(createRoleSchema) {}

export const updateRoleSchema = createRoleSchema.partial();

export class UpdateRoleDto extends createZodDto(updateRoleSchema) {}

export const assignPermissionsSchema = z.object({
  permissionIds: z.string().array().min(1, "At least one permission must be assigned"),
});

export class AssignPermissionsDto extends createZodDto(assignPermissionsSchema) {}
